<template>
    <div class="tab-demographic">
        <div class="blockcont">
            <h2 class="smalltitle">Emergency Contact</h2>
            <div class="prolabel">First name</div>
            <div class="profield">
                <input type="text" placeholder="First Name"
                       v-model="demoInfo.emergencyFirstname" :disabled="disabledForm">
            </div>
            <div class="prolabel">Last name</div>
            <div class="profield">
                <input type="text" placeholder="Last Name"
                       v-model="demoInfo.emergencyLastname" :disabled="disabledForm">
            </div>
            <div class="prolabel">Phone number</div>
            <div class="profield">
                <input type="text" placeholder="Phone number"
                       v-model="demoInfo.emergencyPhone" maxlength="15" :disabled="disabledForm"
                       name="phone">
            </div>
            <div class="prolabel">Relationship to patient</div>
            <div class="profield">
                <select v-model="demoInfo.emergencyRelated" :disabled="disabledForm">
                    <option :value="relate.code" v-for="relate in RELATIONSHIP_STATUS">{{relate.name}}</option>
                </select>
            </div>
        </div>

        <div class="blockcont"><h2 class="smalltitle">Pharmacy Information</h2>
            <div class="prolabel">Pharmacy Name</div>
            <div class="profield">
                <input type="text" placeholder="Name" :disabled="disabledForm"
                                         v-model="demoInfo.pharmacyName">
            </div>
            <div class="prolabel">Phone number</div>
            <div class="profield">
                <input type="text" placeholder="Phone Number" name="phone" :disabled="disabledForm"
                                         v-model="demoInfo.pharmacyPhone">
            </div>
            <div class="prolabel"> Address</div>
            <div class="profield">
                <div class="row">
                    <div class="col-xs-4">
                        <input type="text" placeholder="Street number" :disabled="disabledForm"
                                                 v-model="demoInfo.pharmacyStreetNumber">
                    </div>
                    <div class="col-xs-4">
                        <input type="text" placeholder="Street name" :disabled="disabledForm"
                                                 v-model="demoInfo.pharmacyStreetName">
                    </div>
                    <div class="col-xs-4">
                        <input type="text" placeholder="Suite" :disabled="disabledForm"
                                                 v-model="demoInfo.pharmacySuite">
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-4">
                        <input type="text" placeholder="City" :disabled="disabledForm"
                                                 v-model="demoInfo.pharmacyCity"></div>
                    <div class="col-xs-4">
                        <select v-model="demoInfo.pharmacyState" :disabled="disabledForm"
                                data-ng-options="s.code as s.name for s in stateData">
                            <option value="" disabled selected>State</option>
                        </select>
                    </div>
                    <div class="col-xs-4">
                        <input type="text" placeholder="Zip Code" :disabled="disabledForm"
                                                 v-model="demoInfo.pharmacyZipcode"></div>
                </div>

                <div class="clear"></div>
            </div>
        </div>
        <div class="blockcont"><h2 class="smalltitle">Providers<span class="smallnote"> Optional</span></h2>
            <div class="prolabel note fullw"><strong>Primary Care Physician</strong></div>
            <div class="prolabel">First name</div>
            <div class="profield"><input type="text" placeholder="First Name" :disabled="disabledForm"
                                         v-model="demoInfo.physicianFirstname"></div>
            <div class="prolabel">Last name</div>
            <div class="profield"><input type="text" placeholder="Last Name" :disabled="disabledForm"
                                         v-model="demoInfo.physicianLastname"></div>
            <div class="prolabel">Phone number</div>
            <div class="profield"><input type="text" placeholder="Phone Number" :disabled="disabledForm"
                                         v-model="demoInfo.physicianPhone" name="phone"></div>
            <div class="prolabel note fullw"><strong>Referring Doctor</strong></div>
            <div class="prolabel">First name</div>
            <div class="profield"><input type="text" placeholder="First Name" :disabled="disabledForm"
                                         v-model="demoInfo.referDoctorFirstname"></div>
            <div class="prolabel">Last name</div>
            <div class="profield"><input type="text" placeholder="Last Name" :disabled="disabledForm"
                                         v-model="demoInfo.referDoctorLastname"></div>

        </div>
    </div>
</template>

<script>
import config from '../../../../config'
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
export default {
  name: 'TabDemographic',
  components: {},
  props: {
    disabledForm: {},
    profile: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      demoInfo: {},
      RELATIONSHIP_STATUS: config.RELATIONSHIP_STATUS
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    if (this.profile) {
      this.demoInfo.emergencyFirstname = this.profile.emergencyFirstname
      this.demoInfo.emergencyLastname = this.profile.emergencyLastname
      this.demoInfo.emergencyPhone = this.profile.emergencyPhone
      this.demoInfo.emergencyRelated = this.profile.emergencyRelated

      this.demoInfo.physicianFirstname = this.profile.physicianFirstname
      this.demoInfo.physicianLastname = this.profile.physicianLastname
      this.demoInfo.physicianPhone = this.profile.physicianPhone
      this.demoInfo.referDoctorFirstname = this.profile.referDoctorFirstname
      this.demoInfo.referDoctorLastname = this.profile.referDoctorLastname
      this.demoInfo.pharmacyName = this.profile.pharmacyName
      this.demoInfo.pharmacyPhone = this.profile.pharmacyPhone
      this.demoInfo.pharmacyState = this.profile.pharmacyState
      this.demoInfo.pharmacyCity = this.profile.pharmacyCity
      this.demoInfo.pharmacyZipcode = this.profile.pharmacyZipcode
      this.demoInfo.pharmacyStreetName = this.profile.pharmacyStreetName
      this.demoInfo.pharmacyStreetNumber = this.profile.pharmacyStreetNumber
      this.demoInfo.pharmacySuite = this.profile.pharmacySuite

      this.demoInfo.employeeOccupation = this.profile.employeeOccupation
      this.demoInfo.employeeName = this.profile.employeeName
      this.demoInfo.employeePhone = this.profile.employeePhone
      this.demoInfo.employeeStreetNumber = this.profile.employeeStreetNumber
      this.demoInfo.employeeStreetName = this.profile.employeeStreetName
      this.demoInfo.employeeSuit = this.profile.employeeSuit
      this.demoInfo.employeeCity = this.profile.employeeCity
      this.demoInfo.employeeState = this.profile.employeeState
      this.demoInfo.employeeZip = this.profile.employeeZip

      this.$forceUpdate()
    }
  },
  beforeDestroy () {
  },
  methods: {}
}
</script>
<style scoped="">

</style>
